import React from 'react';
import { Box, Stack } from '@mui/material';
import logo from '../../assets/icons/onryxbrand.png'; // Adjust the path as necessary



const Brand = () => {
    const handleClick = () => {
        window.location.href = 'https://www.on-ryx.com';
    };

    return (
        <Box
            sx={{
                mt: '10px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <Stack direction="row" justifyContent="center" alignItems="center">
                <img
                    src={logo}
                    onClick={handleClick}
                    alt="On-Ryx Brand Logo"
                    style={{ cursor: 'pointer', maxWidth: '100%', height: 'auto' }}
                />
            </Stack>
        </Box>
    );
};

export default Brand;